module.exports = __webpack_public_path__ + "static/media/alpha2.0f6f7072.png";